import { toSentenceCase } from '@omnipresentgroup/helpers';
import type { ClientPolicy } from '@omnipresentgroup/types';
import { type ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';

import { LeaveType } from '../components';

export enum ColumnHeaders {
  country = 'Country',
  category = 'Policy type',
  leaveType = 'Leave type',
  policyDescription = 'Policy',
}

export const useLeaveSettingsTableConfig = ({
  columnsOverride,
}: {
  columnsOverride?: ColumnDef<ClientPolicy, unknown>[];
}) => {
  const columnHelper = useMemo(() => createColumnHelper<ClientPolicy>(), []);

  const columns = useMemo(
    () => [
      columnHelper.accessor('country', {
        cell: (info) => info.getValue().name || '',
        header: () => ColumnHeaders.country,
      }),
      columnHelper.accessor('category', {
        cell: (info) => toSentenceCase(info.getValue() || ''),
        header: () => ColumnHeaders.category,
      }),
      columnHelper.accessor('type', {
        cell: (info) => <LeaveType status={info.getValue()} />,
        header: () => ColumnHeaders.leaveType,
      }),
      columnHelper.accessor('description', {
        cell: (info) => info.getValue() || '',
        header: () => ColumnHeaders.policyDescription,
        size: 1000,
      }),
      ...(columnsOverride ?? []),
    ],
    [columnHelper, columnsOverride],
  );

  return {
    columns,
    columnHelper,
  };
};
